import { Layout, theme } from 'antd';
import AccountSidebar from '../account-sidebar/AccountSidebar.js';
import MainHeader from '../main-header.js';
import classes from './AccountLayout.module.css';
const { Header, Content, Sider } = Layout;

export default function AccountLayout({ children, ...props }) {
   const {
      token: { colorBgContainer },
   } = theme.useToken();
   const { type } = props;
   const page = props.page;
   return (
      <>
         <Layout style={{ minHeight: '100vh' }}>
            <Header
               style={{
                  background: colorBgContainer,
                  paddingInline: '0px',
                  height: '50px',
                  position: 'sticky',
                  top: '0',
                  zIndex: '1000',
                  width: '100%',
               }}
            >
               <MainHeader />
            </Header>

            <Layout className={classes.main}>
               <Sider
                  theme="light"
                  style={{
                     background: '#fafbff',
                     borderInline: '1px solid #e8e8e8',
                  }}
               >
                  <AccountSidebar page={page} />
               </Sider>

               <Content className={classes.container}>{children}</Content>
            </Layout>
         </Layout>
      </>
   );
}
